
/**
 * @export
 * @enum {string}
 */
export enum ResourceType {
    DATASET = 'DATASET'
}